import { React } from "react";
import { Link } from 'react-router-dom';
import "./Login.css";

const Login = () => {
    return (
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="card">
                        <form onsubmit="event.preventDefault()" class="box">
                            <h1>Login</h1>
                            <p class="text-muted"> Please enter your login and password!</p> <input type="text" name="" placeholder="Username"></input> <input type="password" name="" placeholder="Password"></input> <a class="forgot text-muted" href="#">Forgot password?</a>
                            <Link to="/">
                                <input type="submit" name="" value="Login" href="#"></input>
                            </Link>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;